import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPreviewSurveyState } from 'types/previewCampaign';
// import { mockData } from 'pages/admin/survey/mock-data';

const initialState: IPreviewSurveyState = {
    me: {
        id: '',
        type: '',
        creator: false,
    },
    surveyState: {
        answerable: false,
        title: '',
    },
    questions: [],
    capturePerformanceTimeStamp: [],
    capturePerformanceTimeByQuestion: {},
};
const previewSurveySlice = createSlice({
    name: 'previewSurvey',
    initialState,
    reducers: {
        setMe: (
            state,
            action: PayloadAction<{
                id: string;
                type: string;
                creator: boolean;
            }>
        ) => {
            state.me = {
                ...state.me,
                ...action.payload,
            };
        },
        setSurveyState: (
            state,
            action: PayloadAction<{
                answerable: boolean;
            }>
        ) => {
            state.surveyState = {
                ...state.surveyState,
                ...action.payload,
            };
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setListQuestion: (state, action: PayloadAction<any[]>) => {
            state.questions = action.payload;
        },
        captureTimeStamp: (state) => {
            state.capturePerformanceTimeStamp.push(performance.now());
        },
        popCaptureTimeStamp: (state) => {
            state.capturePerformanceTimeStamp.pop();
        },
        resetCaptureTimeStamp: (state) => {
            state.capturePerformanceTimeStamp = [];
        },
        captureTimeByQuestion: (
            state,
            action: PayloadAction<{
                questionId: string;
                time: number;
            }>
        ) => {
            const currentTime =
                state.capturePerformanceTimeByQuestion[
                    action.payload.questionId
                ] || 0;
            state.capturePerformanceTimeByQuestion = {
                ...state.capturePerformanceTimeByQuestion,
                [action.payload.questionId]: currentTime + action.payload.time,
            };
        },
        resetCaptureTimeByQuestion: (state) => {
            state.capturePerformanceTimeByQuestion = {};
        },
    },
});

export const {
    setMe,
    setSurveyState,
    setListQuestion,
    captureTimeStamp,
    captureTimeByQuestion,
    popCaptureTimeStamp,
    resetCaptureTimeStamp,
    resetCaptureTimeByQuestion,
} = previewSurveySlice.actions;

export default previewSurveySlice.reducer;
